export const APP_NAME = 'OPEN STALLS';
export const LOGIN_REGISTER_DESCRIPTION = 'Seamlessly reserve and pay for stalls all across the country';
